module.exports = __webpack_public_path__ + "img/water.5c1f06dc.png";